import { render, staticRenderFns } from "./mo-person-search-source.html?vue&type=template&id=1ad5c014&scoped=true&external"
import script from "./mo-person-search-source.ts?vue&type=script&lang=ts&external"
export * from "./mo-person-search-source.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad5c014",
  null
  
)

export default component.exports